/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

// Link fields need a full http(s) URL with a dotted host — values like
// "www.site.com" are rejected server-side (BG-22982).
export default function isValidUrl(text: string) {
  const authority = /^https?:\/\/([^/?#]+)/i.exec(text)?.[1];
  if (!authority || authority.includes("@")) return false;
  try {
    const { hostname } = new URL(text);
    return /^[^.]+(\.[^.]+)+$/.test(hostname);
  } catch {
    return false;
  }
}

// Users often type "www.site.com" — trim and default to https:// when no
// scheme is given.
export function normalizeUrl(text: string) {
  const trimmed = text.trim();
  if (!trimmed || /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}
